import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

type Props = React.PropsWithChildren<{
  gap?: string;
}>;

const useHorizontalGridStyles = makeThemedStyles("HorizontalGrid", (theme) => ({
  horizontalGrid: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "center",
    "& > div": {
      flex: 1,
    },
  },
}));

const HorizontalGrid = (props: Props) => {
  const gap = props.gap || "20px";
  const classes = useHorizontalGridStyles();
  return (
    <div className={classes.horizontalGrid} style={{ gap }}>
      {props.children}
    </div>
  );
};

export default HorizontalGrid;
